import router from "../../router";
import { $api, User } from "@/shared";
import { ApiResourceResult } from "@/shared/vuex";

export class UsersClass {
  /**
   *
   * @returns
   * @improve this to only retrieve the .query
   */
  static fetch() {
    console.log(router);
    return $api.admin
      .get<ApiResourceResult<User>>(
        `/v1/users?${router.currentRoute.value.fullPath.split("?")[1] || ""}`
      )
      .then((resp) => {
        return resp.data;
      });
  }
}
